import * as React from 'react';
import { getBasicGridData } from "../services/index.mjs";
export const useBasicDemoData = (nbRows, nbCols) => {
  return React.useMemo(() => getBasicGridData(nbRows, nbCols), [nbRows, nbCols]);
};